import { Dialog, VisuallyHidden } from 'radix-ui'
import { lazy, Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { m } from '~/paraglide/messages'
import { DetailsIcon } from './icons/details'
import { Spinner } from '@forest/shared/react'

const EventDetailsDialogLazyContent = lazy(() =>
  import('./event-details-dialog-lazy-content').then((mod) => ({
    default: mod.EventDetailsDialogLazyContent,
  })),
)

export function EventDetailsDialog() {
  return (
    <Dialog.Root>
      <Dialog.Trigger>
        <DetailsIcon />
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Content className="fixed inset-0 z-20 overflow-y-auto bg-white px-6 pb-12 pt-[calc(80px+var(--safe-area-top))] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0">
          <div className="fixed left-4 right-4 top-0 pt-[calc(18px+var(--safe-area-top))]">
            <Dialog.Close asChild>
              <CloseButton />
            </Dialog.Close>
          </div>
          <VisuallyHidden.Root>
            <Dialog.Title>Event Details</Dialog.Title>
          </VisuallyHidden.Root>
          <Dialog.Description className="text-sm text-[#333]" asChild>
            <div className="prose">
              <ErrorBoundary
                fallback={
                  <div className="space-y-2">
                    <h2 className="text-lg">
                      {m.dialog_data_load_fail_title()}
                    </h2>
                    <p>{m.dialog_data_load_fail_description()}</p>
                  </div>
                }
              >
                <Suspense
                  fallback={
                    <div className="fixed inset-0 grid place-items-center">
                      <Spinner className="size-9 text-[#333]" />
                    </div>
                  }
                >
                  <EventDetailsDialogLazyContent />
                </Suspense>
              </ErrorBoundary>
            </div>
          </Dialog.Description>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

function CloseButton({
  ref,
  ...props
}: { ref?: React.Ref<HTMLButtonElement> } & React.ComponentProps<'button'>) {
  return (
    <button
      className="size-[42px] rounded-full bg-white/80 backdrop-blur-md"
      ref={ref}
      {...props}
    >
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="pointer-events-none"
      >
        <g data-figma-bg-blur-radius="87.5">
          <rect
            x="0.875"
            y="0.875"
            width="40.25"
            height="40.25"
            rx="20.125"
            stroke="url(#paint0_linear_20963_53142)"
            strokeWidth="1.75"
          />
          <path
            d="M16 16L25.9999 25.9999"
            stroke="#333333"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          <path
            d="M16.0001 25.9999L26 16"
            stroke="#333333"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_20963_53142"
            x1="22.4882"
            y1="-7.88143e-07"
            x2="34.3401"
            y2="38.3359"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0.3" />
            <stop offset="1" stopColor="white" stopOpacity="0.1" />
          </linearGradient>
        </defs>
      </svg>
    </button>
  )
}
